import { render } from "./MatchPairMultiplyExerciseComponent.vue?vue&type=template&id=28bc64f0&scoped=true"
import script from "./MatchPairMultiplyExerciseComponent.vue?vue&type=script&lang=js"
export * from "./MatchPairMultiplyExerciseComponent.vue?vue&type=script&lang=js"

import "./MatchPairMultiplyExerciseComponent.vue?vue&type=style&index=0&id=28bc64f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bc64f0"]])

export default __exports__